import axios from 'axios';

const firebaseAPI = "https://portofolio-d8d41-default-rtdb.firebaseio.com"

export const getExperience = () => axios.get(`${firebaseAPI}/experience.json`);
export const getProject = () => axios.get(`${firebaseAPI}/project.json`);
export const getTags = () => axios.get(`${firebaseAPI}/tags.json`);